export default __webpack_public_path__ + "static/media/BearerLogo.b5677bb9.png";